import {createContext} from 'react';

const ComponentDataContext = createContext({});

export default ComponentDataContext;
